module.exports = __webpack_public_path__ + "static/media/madhya_pradesh.fadee32c.png";